import { type RefObject, useEffect, useRef } from "react";
import { useScroll } from "react-use";

export const useMainScroll = () => {
  const mainRef = useRef<HTMLElement | null>(null);

  useEffect(() => {
    mainRef.current = document.querySelector("main");
  }, []);

  // https://github.com/streamich/react-use/issues/2612
  return useScroll(mainRef as RefObject<HTMLElement>);
};
